import React from 'react';
import { reportClientError } from '../utils/logger';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    reportClientError('React Component Crash', error, {
      stack: errorInfo?.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-[#FDFCFB] p-6 text-center">
          <h1 className="text-2xl font-bold text-red-600 mb-2">Something went wrong</h1>
          <p className="text-gray-600 mb-4">The application encountered an unexpected layout crash.</p>
          <button 
            onClick={() => window.location.reload()} 
            className="px-4 py-2 bg-[#D96245] text-white rounded hover:bg-[#c25035] transition"
          >
            Reload Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
